import classNames from 'classnames';
import React from 'react';

import {assert} from 'Asserts';
import * as SampleConstants from 'constants/SampleConstants';
import {Bioentity} from 'folder-items/FileConstants';
import {restToGraphQL} from 'graphql-client/declarative-translations/external/translate';
import {makeStageRunSample, updateSampleGroupWithSample} from 'requests/samples-table/RequestSampleTableUtil';
import SelectRequestSampleForm from 'requests/SelectRequestSampleForm';
import {isSampleFieldForBioentity, SampleLinkSchemaField} from 'schemas/fields/SchemaFieldConstants';
import FormGroup from 'ui-library/bs/FormGroup';
import Label from 'ui-library/bs/Label';
import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal from 'ui-library/modals/Modal';
import makeSampleGroup from 'workflows/samples/makeSampleGroup';
import {PreparedUISampleGroup} from 'workflows/samples/PreparedSampleGroupConstants';
import {SampleGroupSchema} from 'workflows/WorkflowConstants';

export interface AddRequestSampleRowModalProps {
  onRequestClose: () => void;
  onRequestSubmit: (sampleGroup: PreparedUISampleGroup) => void;
  sampleGroupSchema: SampleGroupSchema;
}

interface State {
  sampleGroup: PreparedUISampleGroup;
}

export default class AddRequestSampleRowModal extends React.Component<AddRequestSampleRowModalProps, State> {
  override state: State = {
    sampleGroup: makeSampleGroup(),
  };

  _handleSubmit = (): void => {
    this.props.onRequestSubmit(this.state.sampleGroup);
  };

  _handleChangeSelectedSample = (
    field: SampleLinkSchemaField,
    selectedSample: {
      sample: Bioentity;
      container: SampleConstants.Container | null;
    } | null
  ): void => {
    const stageRunSample = selectedSample
      ? makeStageRunSample(selectedSample.sample, selectedSample.container)
      : null;
    this.setState({
      // @ts-expect-error
      sampleGroup: updateSampleGroupWithSample(
        restToGraphQL('SampleGroupSchema', this.props.sampleGroupSchema),
        // @ts-expect-error
        this.state.sampleGroup,
        field.name,
        stageRunSample
      ),
    });
  };

  override render(): JSX.Element {
    return (
      <Modal
        title="Add row"
        onRequestClose={this.props.onRequestClose}
        onRequestSubmit={this._handleSubmit}
        buttons={[
          {
            text: 'Add',
            submit: true,
            style: ButtonStyle.PRIMARY,
            // All fields are optional
            disabled: false,
            key: 'add',
          },
        ]}
      >
        {this.props.sampleGroupSchema.fields.map((field: SampleLinkSchemaField, i: number) => {
          assert(isSampleFieldForBioentity(field), 'Batch is not supported');
          const sampleSchemaSummary = field.requiredLink.tagSchema;

          return (
            <FormGroup key={field.apiId} className={classNames({'u-large-spacing-top': i > 0})}>
              <Label>{field.name}</Label>
              <SelectRequestSampleForm
                autoFocus={false}
                sampleSchemaSummary={sampleSchemaSummary || null}
                sampleType={field.requiredLink.sampleType}
                onSelectedSampleChanged={(
                  selectedSample: {
                    sample: Bioentity;
                    container: SampleConstants.Container | null;
                  } | null
                ) => {
                  this._handleChangeSelectedSample(field, selectedSample);
                }}
              />
            </FormGroup>
          );
        })}
      </Modal>
    );
  }
}
